import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';
import { GetPreferenceValueParsed, GetPreferenceValue } from '@utils';
import { ModalBanner } from '@components';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { BANNER_PRIMARY_PHOTO_FIELD_KEY, IAccount } from '@share/common-types';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IProps extends WrappedComponentProps, RouteComponentProps {
  account: IAccount | null;
  fieldUrl: string;
  fieldImage: string;
  title: string;

  titleKey?: string;
  titleKeyModal?: string;

  onClick: (url: string, file: any) => void;
  handleLogoRemove?: (key: string) => void;
}

interface IState {
  displayBanner: boolean;
  localImage?: any;
}


export const NO_CHOSEN_FILE_MESSAGE = 'No file chosen';

class AccountBannerComponent extends React.Component<IProps, IState> {

  state: IState = {
    displayBanner: false,
    localImage: GetPreferenceValueParsed(
      this.props.account,
      this.props.fieldImage,
      `{ "Key": "${NO_CHOSEN_FILE_MESSAGE}" }`
    )
  };

  handleSubmit = (url: string, file: any) => {
    const fileData = file.target.files[0] as File;
    if (fileData instanceof Blob) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const result = (e.target as FileReader).result;
          this.setState({
              localImage: {
                  Key: fileData.name,
                  Value: result 
              }
          });
      };
      reader.readAsDataURL(fileData);
    } 
    const { onClick } = this.props;
    this.setState({ displayBanner: false });
    onClick(url, file);
  }

  componentDidMount() {
    const { account, fieldImage } = this.props;
    const image = GetPreferenceValueParsed(account, fieldImage, `{ "Key": "${NO_CHOSEN_FILE_MESSAGE}"}`);
    this.setState({ localImage: image });
  }
  
  render(): React.ReactNode {
    const { account, title, fieldUrl, fieldImage, titleKey, titleKeyModal, intl } = this.props;
    const { displayBanner } = this.state;

    const url = GetPreferenceValue(account, fieldUrl);
    const image = GetPreferenceValueParsed(account, fieldImage, `{ "Key": "${NO_CHOSEN_FILE_MESSAGE}"}`);
    const hasBannerImage = image && image?.Key != NO_CHOSEN_FILE_MESSAGE;


    const handleLogoRemoves = (key: string, fieldKey : string) => {
      const image = GetPreferenceValueParsed(account, fieldKey);
      if (image && image?.Key === key) {
        this.setState({
          localImage: { Key: key, Value: '' }
        });
        this.props.handleLogoRemove && this.props.handleLogoRemove(fieldKey);
      }
    }
    
    return (
      <>
        <div className="row gx-0">
          <div className="col-12 px-0">
            <label className="title mb-2"><FormattedMessage id={title} /></label>
          </div>
          <div className="col-12 px-0 save-account__fields-row form-input-container">
            <div className="save-account__input">
              <span onClick={() => this.setState({ displayBanner: true })}>
                <span className='btn btn-light btn-branding'>
                {hasBannerImage && this.state.localImage?.Value ? intl.formatMessage({ id: 'edit' }) : intl.formatMessage({ id: 'upload' })}
                </span>
              </span>
              {/* {this.state.localImage?.Value && (
                <div className="brandingColor_right">
                  <FontAwesomeIcon
                    icon={faTimesCircle}
                    className="save-branding__clear-property"
                    onClick={() => handleLogoRemoves && handleLogoRemoves(this.state.localImage?.Key,fieldImage)}
                  />
                </div>
              )} */}
            </div>
          </div>
        </div>

        <ModalBanner
          key={new Date().getTime()}
          titleKey={titleKeyModal}
          imageKey={fieldImage.toLowerCase()}
          imageName={!isEmpty(image?.Key) ? image?.Key : NO_CHOSEN_FILE_MESSAGE}
          visible={displayBanner}
          url={!isEmpty(url) ? url : ''}
          onCancel={() => this.setState({ displayBanner: false })}
          onSave={this.handleSubmit}
        />
      </>
    );
  }
}

const AccountBannerComponentWithRouter = withRouter(injectIntl(AccountBannerComponent));

export const AccountBanner = connect()(AccountBannerComponentWithRouter);
